import { ChangeEvent, LegacyRef } from 'react';
import styles from './Checkbox.module.scss';

interface CheckboxI {
  value?: string;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  ref?: LegacyRef<HTMLInputElement> | undefined;
  label?: string;
  className?: string;
  checked: boolean;
}

export const Checkbox = ({ value, onChange, ref, label, className, checked, disabled }: CheckboxI) => {
  return (
    <label className={styles.label} aria-disabled={disabled}>
      <input
        ref={ref}
        className={className}
        type="checkbox"
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      {label}
    </label>
  );
};
